export const urls: any = [
  {
    _ambiente: 'Local',
    _ambienteAbrev: 'LCL',
    caaVirtual: '',
    campanhaCovid19Aluno: '',
    campanhaCovid19Atendimento: '',
    lyceumAluno: '',
    lyceumDocente: '',
    lyceumSecretaria: '',
    meuRH: '',
    uniFTC: '',
  },
  {
    // Fixos
    _ambiente: 'Produção',
    _ambienteAbrev: 'PRO',
    caaVirtual: 'https://topdesk.uniftc.edu.br',
    lyceumDocente: 'https://docente.uniftc.edu.br',
    lyceumSecretaria: 'https://secretaria.uniftc.edu.br',
    // Dependentes do Domínio
    campanhaCovid19Aluno: 'https://covid19.ftc.edu.br/',
    campanhaCovid19Atendimento: 'https://atendimentocovid19.ftc.edu.br/login',
    lyceumAluno: 'https://portalaluno.uniftc.edu.br',
    meuRH: 'https://meurh.ftc.br',
    uniFTC: 'https://aluno.uniftc.edu.br',
    bitrix: 'https://uniftc.bitrix24.com.br',
  },
  {
    _ambiente: 'PRP',
    _ambienteAbrev: 'PRP',
    caaVirtual: '',
    campanhaCovid19Aluno: '',
    campanhaCovid19Atendimento: '',
    lyceumAluno: '',
    lyceumDocente: '',
    lyceumSecretaria: '',
    meuRH: '',
    uniFTC: '',
  },
  {
    _ambiente: 'Teste',
    _ambienteAbrev: 'TST',
    caaVirtual: '',
    campanhaCovid19Aluno: '',
    campanhaCovid19Atendimento: '',
    lyceumAluno: '',
    lyceumDocente: '',
    lyceumSecretaria: '',
    meuRH: '',
    uniFTC: '',
  },
  {
    _ambiente: 'UAT',
    _ambienteAbrev: 'UAT',
    caaVirtual: '',
    campanhaCovid19Aluno: '',
    campanhaCovid19Atendimento: '',
    lyceumAluno: '',
    lyceumDocente: '',
    lyceumSecretaria: '',
    meuRH: '',
    uniFTC: '',
  },
  {
    _ambiente: 'Desenvolvimento',
    _ambienteAbrev: 'DEV',
    caaVirtual: '',
    campanhaCovid19Aluno: '',
    campanhaCovid19Atendimento: '',
    lyceumAluno: 'http://10.255.6.50:8282',
    lyceumDocente: 'https://prpdocente.ftc.br',
    lyceumSecretaria: 'https://prpsecretaria.ftc.br',
    meuRH: '',
    uniFTC: 'https://prpaluno.uniftc.edu.br',
  },
];
